<template>
  <div>
    <div class=" d-flex mb-4">
      <BackToProposal style="margin-top: -12px !important;" />
      <!-- TODO -->
      <!-- <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <div v-bind="attrs" v-on="on" class="ml-1">
            <AddPricingOption />
          </div>
        </template>
        <span>Add pricing option</span>
      </v-tooltip> -->
      <div class="d-flex" v-if="!isChildProposal">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on">
              <v-btn
                rounded
                dark
                small
                class="global-button-vuetify ml-4 main-button"
                color="primary"
                @click="autofill()"
              >
                <v-icon class="mr-1">mdi-auto-download</v-icon>
              </v-btn>
            </div>
          </template>
          <span>Autofill pricing plans</span>
        </v-tooltip>

        <v-menu offset-y>
          <template v-slot:activator="{ on: menu, attrs }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on: tooltip }">
                <div v-bind="attrs" v-on="{ ...tooltip, ...menu }">
                  <v-btn
                    dark
                    small
                    class="global-button-vuetify dropdown-button"
                    color="primary"
                  >
                    <v-icon>mdi-menu-down</v-icon>
                  </v-btn>
                </div>
              </template>
              <span>Select template</span>
            </v-tooltip>
          </template>
          <v-list>
            <v-list-item @click="autofill('startups_three_level')">
              <v-list-item-title>Startups Three Level</v-list-item-title>
            </v-list-item>
            <v-list-item @click="autofill('outstaff_outsource')">
              <v-list-item-title>Outstaff & Outsource</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <div v-bind="attrs" v-on="on">
            <v-btn
              fab
              dark
              small
              class="global-button-vuetify ml-4"
              color="primary "
              @click="calculate"
              v-if="!isChildProposal"
            >
              <v-icon class="px-2">mdi-calculator</v-icon>
            </v-btn>
          </div>
        </template>
        <span>Calculate child proposals</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <div v-bind="attrs" v-on="on" class="mt-1 ml-5">
            <v-switch
              v-model="isEnabled"
              label="Plans"
              :true-value="true"
              :false-value="false"
              :loading="isLoading"
              :disabled="isLoading"
              v-if="!isChildProposal"
              color="blue"
            ></v-switch>
          </div>
        </template>
        <span>{{ isEnabled ? 'Disable pricing plans' : 'Enable pricing plans' }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <div v-bind="attrs" v-on="on" class="mt-1 ml-5">
            <v-switch
              v-model="isService"
              label="Services"
              :true-value="true"
              :false-value="false"
              :loading="isLoading"
              :disabled="isLoading"
              v-if="!isChildProposal"
              color="blue"
            ></v-switch>
          </div>
        </template>
        <span>{{ isService ? 'Disable pricing services' : 'Enable pricing services' }}</span>
      </v-tooltip>
    </div>
    <div class="d-flex flex-column">
      <v-card-text style="width: 100%; height: 60vh;" class="d-flex justify-center align-center px-0 py-0" v-if="isLoading">
        <v-progress-circular
          class="mx-auto"
          :size="60"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </v-card-text>
      <div v-if="!isLoading" class="pricing-plan-edit">
        <PricingOptions />
      </div>
      <div v-if="!isLoading" class="toolbar">
        <PricingItems class="toolbar-stick" />
      </div>
    </div>
  </div>
</template>

<script>
import BackToProposal from "@/components/ProposalDetailed/Actions/BackToProposal";
import PricingOptions from "../components/ProposalDetailed/PricingPlans/PricingOptions";
import PricingItems from "../components/ProposalDetailed/PricingPlans/PricingItems";
// import AddPricingOption from "../components/ProposalDetailed/Actions/AddPricingOption.vue";
import axiosInstance from "@/axios";

export default {
  components: {
    BackToProposal,
    PricingOptions,
    PricingItems,
    // AddPricingOption,
  },
  data: () => ({
    isLoading: false,
  }),
  async created() {
    await this.refreshProposalData();
  },
  computed: {
    isChildProposal() {
      return this.$store.state.isChildProposal;
    },
    isDataEmpty() {
      return this.$store.state.pricingPlans.length;
    },
    proposalId() {
      return Number(this.$route.params.id);
    },
    isEnabled: {
      get() {
        return this.$store.state.settings.enableProposalPackages;
      },
      set(value) {
        this.toggleEnable(value);
      },
    },
    isService: {
      get() {
        return this.$store.state.settings.enablePackageServices;
      },
      set(value) {
        this.toggleServiceEnable(value);
      },
    },
  },
  methods: {
    async toggleEnable(value) {
      if (typeof value !== 'boolean') return;

      this.isLoading = true;
      try {
        await axiosInstance.put(
          `/proposal/${this.proposalId}/settings/packages/${value}`,
        );

        this.$store.commit("setEnablePricingPlans", value);
        await this.refreshProposalData();
      } catch (err) {
        console.log(err);
      } finally {
        this.isLoading = false;
      }
    },
    async toggleServiceEnable(value) {
      if (typeof value !== 'boolean') return;

      this.isLoading = true;
      try {
        await axiosInstance.put(
          `/proposal/${this.proposalId}/settings/packages/services/${value}`,
        );

        this.$store.commit("setEnablePricingPlansItems", value);
        await this.refreshProposalData();
      } catch (err) {
        console.log(err);
      } finally {
        this.isLoading = false;
      }
    },
    async autofill(template) {
      this.isLoading = true;
      try {
        let url = `/proposal/${this.proposalId}/package/auto`;

        if (template) {
          url += `?template=${template}`;
        }

        await axiosInstance.post(url);
        await this.refreshProposalData();
      } catch (err) {
        console.log(err);
      } finally {
        this.isLoading = false;
      }
    },
    async calculate() {
      this.isLoading = true;
      try {
        await axiosInstance.post(
          `/proposal/${this.proposalId}/package/sync`,
        );

        await this.refreshProposalData();
      } catch (err) {
        console.log(err);
      } finally {
        this.isLoading = false;
      }
    },
    async refreshProposalData() {
      await this.$store.dispatch("getCurrentProposalData", this.proposalId);
      await this.$store.dispatch("refreshPricingPlansItems", this.$route.params.id);
    },
  },
};
</script>

<style scoped>
.pricing-plan-edit {
  flex: 7;
}
.toolbar {
  flex: 5;
}
.toolbar-stick {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  right: 1px;
}

.error-tip {
  font-size: 21px;
}
.toolbar-stick {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  right: 1px;
}
.full-block {
  padding: 15% 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.went-wrong-message {
  font-size: 28px;
}
.link-message {
  text-decoration: none;
  font-size: 16px;
  font-weight: 600;
  color: #92278e;
  text-transform: uppercase;
}
.link-message:hover {
  opacity: 0.7;
}
.main-button {
  height: 40px !important;
  border-right: none !important;
  padding-left: 8px !important;
  padding-right: 4px !important;
  min-width: 0 !important;

  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
  border-top-left-radius: 28px !important;
  border-bottom-left-radius: 28px !important;
}
.dropdown-button {
  height: 40px !important;
  border-left: none !important;
  padding-left: 5px !important;
  padding-right: 10px !important;
  min-width: 0 !important;

  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
  border-top-right-radius: 28px !important;
  border-bottom-right-radius: 28px !important;
}
</style>
